export const instrumentRoutes = {
  getInstruments: 'v2/instrument',
  getRelatedInstruments: '/instrument/related?take=20',
  getExchangeRateInstruments: '/instrument/rate',
  getInstrumentSpecification: 'v2/instrument/specification',
  getInstrumentTradersTrend: '/instrument/traders-trend',
  favorite: 'v2/instrument/favorite',
} as const;
